// extracted by mini-css-extract-plugin
export default {"info-bar":"InfoBar_info-bar__V0Rwa","no-divider":"InfoBar_no-divider__mB3PZ","info-bar-body":"InfoBar_info-bar-body__cNHmz","info-bar-extra":"InfoBar_info-bar-extra__UmAJw"};